
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card, Button, Form } from 'react-bootstrap';
import { IoEyeOutline } from "react-icons/io5";
import { FaExclamationTriangle } from "react-icons/fa";
import { BiMessageSquareDetail } from "react-icons/bi";
import AwaitingInspection from './AwaitingInspection';
import UnderInspection from './UnderInspection';
import ReadyForDipatch from './ReadyForDipatch';
import { TrendingUp } from 'react-feather';
import { TrendingDown } from 'lucide-react';
import { FiDownload } from "react-icons/fi";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
const InspectionDashboard = () => {
    const [activeTab, setActiveTab] = useState('Awaiting Inspection');
    const [inspectiondashboard, setInspectiondashboard] = useState([])
    const [metrics, setMetrics] = useState([]);
    const fetchInspectiondashboard = async () => {
        const token = getAuthToken();
        if (!token) return;
        try {
            const response = await axios.get(`${config.API}/inspection/dashboard`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            });
            const result = response.data;
            setInspectiondashboard(result);
            console.log("fetchInspectiondashboard Data:", result);
        } catch (err) {
            console.error("Error fetching fetchInspectiondashboard:", err.message);
        }
    };
    useEffect(() => {
        fetchInspectiondashboard()
    }, [])
    const renderContent = () => {
        switch (activeTab) {
            case 'Awaiting Inspection':
                return <AwaitingInspection />;
            case 'Under Inspection':
                return <UnderInspection />;
            case 'Ready For Dispatch':
                return <ReadyForDipatch />;
            default:
                return <AwaitingInspection />;
        }
    };
    useEffect(() => {
        if (inspectiondashboard) {
            setMetrics([
                {
                    title: "Monthly Production",
                    value: inspectiondashboard?.unit_completed || 0,
                    subtitle: "of Target",
                    icon: (
                        <div style={{
                            backgroundColor: '#e0ebff',
                            borderRadius: '50%',
                            padding: '10px',
                            width: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <TrendingUp color="#1D4ED8" size={18} />
                        </div>
                    )
                },
                {
                    title: "Quality Metrics", value: inspectiondashboard?.nc, subtitle: "First Pass Yield",
                    icon: (
                        <div style={{
                            backgroundColor: '#b0f0d8ff',
                            borderRadius: '50%',
                            padding: '10px',
                            width: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <TrendingUp color="#0c7549ff" size={18} />
                        </div>
                    )
                },
                {
                    title: "Machine Utilization", value: inspectiondashboard?.machineutilization
                        ? Number(inspectiondashboard.machineutilization).toFixed(2)
                        : "0.00", subtitle: "Avg. Utilization",
                    icon: (
                        <div style={{
                            backgroundColor: '#fff4c2',         
                            borderRadius: '50%',
                            padding: '10px',
                            width: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <TrendingDown color="#8B2500" size={18} /> {/* Brown arrow */}
                        </div>
                    )
                },
                {
                    title: "Resource Efficiency", value: inspectiondashboard?.resourceefficiency
                        ? Number(inspectiondashboard.resourceefficiency).toFixed(2)
                        : "0.00", subtitle: "Labor + Material",
                    icon: (
                        <div style={{
                            backgroundColor: '#e0ebff',
                            borderRadius: '50%',
                            padding: '10px',
                            width: 'fit-content',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <TrendingUp color="#1D4ED8" size={18} />
                        </div>
                    )
                },
            ]);
        }
    }, [inspectiondashboard]);
    return (
        <div className="container-fluid p-4" style={{ background: "#EEF2F8" }}>
            <div className="row font_family">
                <div className="col-lg-1" />
                <div className="col-lg-10">
                    <div className="row">
                        <div className="row align-items-center mb-4">
                            <div className="col-12 col-md-6">
                                <strong className='fs-4'>Inspection Dashboard</strong>
                            </div>
                            <div className="col-12 col-md-6 text-md-end mt-3 mt-md-0">
                                <Form.Control type="month" defaultValue="2025-06" className="d-inline w-auto me-2" />
                                <Button className='btn btn-light'><FiDownload /> Export</Button>
                            </div>
                        </div>
                        <div className="row mb-4">
                            {metrics.map((metric, idx) => (
                                <div className="col-12 col-sm-6 col-md-3 mb-3" key={idx}>
                                    <Card border={metric.color} className="w-100 h-100">
                                        <Card.Body>
                                            <Card.Title>{metric.title}</Card.Title>
                                            <h4 className="fw-bold d-flex justify-content-between align-items-center">
                                                {metric.value}
                                                <span>{metric.icon}</span>
                                            </h4>
                                            <small>{metric.subtitle}</small>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ))}
                        </div>
                        <div className=" row rounded text-dark px-2 py-1 font_family  py-1 m-1" style={{ background: "#e0e9fbff" }}>
                            <div className='col-md-4'><TabItem
                                label="Awaiting Inspection"
                                icon={<IoEyeOutline />}
                                active={activeTab === 'Awaiting Inspection'}
                                onClick={() => setActiveTab('Awaiting Inspection')}
                            /></div>
                            <div className='col-md-4'><TabItem
                                label="Under Inspection"
                                icon={<FaExclamationTriangle />}
                                active={activeTab === 'Under Inspection'}
                                onClick={() => setActiveTab('Under Inspection')}
                            /></div>
                            <div className='col-md-4'><TabItem
                                label="Ready For Dispatch"
                                icon={<BiMessageSquareDetail />}
                                active={activeTab === 'Ready For Dispatch'}
                                onClick={() => setActiveTab('Ready For Dispatch')}
                            /></div>
                        </div>
                        <div className="mt-2">
                            {renderContent()}
                        </div>
                    </div>
                </div>
                <div className="col-lg-1" />
            </div>
        </div>
    );
};
function TabItem({ label, icon, active, onClick }) {
    return (
        <div
            className={`flex-fill text-center py-2 rounded d-flex align-items-center justify-content-center gap-2 ${active ? 'bg-light text-dark fw-bold' : ''
                }`}
            style={{ cursor: 'pointer' }}
            onClick={onClick}
        >
            {icon}
            <span>{label}</span>
        </div>
    );
}

export default InspectionDashboard;
